module.exports = __webpack_public_path__ + "img/payment-inAdvance.b14dc82.svg";